import React from 'react';
import styled from 'astroturf/react';

import { BundleWork } from './types';

const BUCKET_LABEL: Record<string, string> = {
  citingThis: 'Cites',
  citedByThis: 'Cited by',
  topRelated: 'Similar',
  sameAuthor: 'By same author',
};

/**
 * Small chip surfacing the relational provenance of a work card when
 * V14 (`bucket_badges_v14`) is active. The bucket value is already on
 * `BundleWork.bucket`; this component just maps it to a human label.
 *
 * Returns null for the source paper (`thePaperItself`) and for unknown
 * buckets — the variant should not crash on a backend-introduced bucket
 * the labels map doesn't cover.
 */
export function BucketBadge({ bucket }: { bucket: BundleWork['bucket'] }) {
  if (!bucket || bucket === 'thePaperItself') return null;
  const label = BUCKET_LABEL[bucket];
  if (!label) return null;
  return <Chip>{label}</Chip>;
}

const Chip = styled('span')`
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 6px;
  font-size: 10px;
  border-radius: 4px;
  background-color: var(--color-surface-alt-secondary, #eef0f2);
  color: var(--color-text-secondary, #555);
`;
